/**
 * Local action types for the Assessment Status Indicators feature.
 * These are separate from @futures-platform/reducers/actionTypes to avoid
 * modifying the external package.
 */

export const SET_ASSESSMENT_STATUS_VISIBLE = 'SET_ASSESSMENT_STATUS_VISIBLE'
export const SET_ASSESSMENT_DATA           = 'SET_ASSESSMENT_DATA'
export const SET_ASSESSMENT_SUMMARY        = 'SET_ASSESSMENT_SUMMARY'
